import MuiBox, { BoxProps as MuiBoxProps } from '@material-ui/core/Box';

export interface BoxProps extends MuiBoxProps {
  center?: boolean;
}

export const Box = ({ center, ...props }: BoxProps) => (
  <MuiBox
    display={center ? 'flex' : null}
    flexDirection={center ? 'column' : null}
    justifyContent={center ? 'center' : null}
    alignItems={center ? 'center' : null}
    {...props}
  />
);
